import React from 'react';
import styled from 'styled-components';
import { H1, H4, P, Text, PSmall } from '../../../components/Typography/Typography';
import { JoinPrimary } from '../../../components-legacy/Buttons/JoinNow';
import { media } from '../../../components/style-utils';

export const SectionPricing = function() {
  return (
    <Container id="pricing">
      <Headline>Join Now</Headline>
      <CardBox>
        <PriceCard
          byline={
            <CardByline>
              Option 1.{' '}
              <Circled>
                <b>Save 15%!</b>
              </Circled>
            </CardByline>
          }
          cost="$2,997"
          description="one-time"
          buttonUrl="https://the167.mykajabi.com/offers/eLaMztop"
        />
        <PriceCard
          byline={<CardByline>Option 2</CardByline>}
          cost="$1,147"
          description="three payments"
          buttonUrl="https://the167.mykajabi.com/offers/JfG9M265/checkout"
        />
        <PriceCard
          byline={<CardByline>Option 3</CardByline>}
          cost="$599"
          description="six payments"
          buttonUrl="https://the167.mykajabi.com/offers/MiNy6ChX"
        />
      </CardBox>
    </Container>
  );
};

const Container = styled.section`
  padding-top: 4rem;
  margin: 0;
  position: relative;
  width: 100vw;
  overflow: hidden;
`;

const Headline = styled(H1)`
  text-align: center;
`;

const CardBox = styled.ul`
  padding: 0 1.2rem;

  display: flex;
  flex-direction: column;
  align-items: center;

  ${media.mediumDesktopAndUp`
    flex-direction: row;
    justify-content: center;
  `}
`;

const PriceCard = function({ byline, cost, description, buttonUrl }) {
  return (
    <Card>
      {byline}
      <CardPrice cost={cost} byline={description} />
      <FeatureList>
        <FeatureItem>
          <ItemText style={{ fontWeight: 700 }}>Comes with 30-day guarantee.</ItemText>
          <ItemText>If you’re not satisfied, we’ll offer a refund! Includes all course deliverables:</ItemText>
        </FeatureItem>
        <FeatureItem>
          <ItemHeadline>Course Curriculum</ItemHeadline>
          <ItemText>Learn the 6-part process for using social media to accomplish your church’s biggest goals</ItemText>
        </FeatureItem>
        <FeatureItem>
          <ItemHeadline>Hands-On Mentorship</ItemHeadline>
          <ItemText>
            Accelerate your growth with unlimited 1-on-1 email access, attend weekly live training calls, and connect
            with other churches on the same path
          </ItemText>
        </FeatureItem>
        <FeatureItem>
          <ItemHeadline>The 1-Year Social Media Calendar</ItemHeadline>
          <ItemText>
            Gain instant access to 365 planned out social media posts that will cover you for the full year (plus, all
            the source files & templates)
          </ItemText>
        </FeatureItem>
        <FeatureItem>
          <ItemHeadline>Execution Plans</ItemHeadline>
          <ItemText>
            Look over Brady’s shoulder as he builds, optimizes, and executes high-level social media strategies
          </ItemText>
        </FeatureItem>
        <FeatureItem>
          <HighlightBox>
            <ItemHeadline>Lifetime Access</ItemHeadline>
            <ItemText>
              Being part of the inaugural class for The 167 means you’ll get a direct say in the training we produce -
              you’ll also receive lifetime access to all future training and courses
            </ItemText>
          </HighlightBox>
        </FeatureItem>
      </FeatureList>
      <StyledJoinPrimary href={buttonUrl} />
    </Card>
  );
};

const StyledJoinPrimary = styled(JoinPrimary)`
  display: flex;
  margin: 0 auto;
`;

const Card = styled.li`
  background-color: var(--colorBlack);
  color: var(--colorWhite);

  margin: 2.5rem 1rem 0;
  border-radius: 2.6rem;
  padding: 7rem 4rem 3rem;

  max-width: 60rem;
`;

const CardByline = styled(P)`
  margin: 0;
`;

const Circled = styled.span`
  border-radius: 50%;
  border: solid var(--colorPrimaryMedium) 0.2rem;
  overflow: visible;
`;

const CardPrice = function({ cost, byline }) {
  return (
    <H4>
      <div>
        {cost} <Currency>USD</Currency>
      </div>
      <div>{byline}</div>
    </H4>
  );
};

const Currency = styled(Text)`
  opacity: 0.6;
  font-weight: 500;
`;

const ItemHeadline = styled(P)`
  margin: 2rem 0 0;
  font-weight: 900;
`;

const ItemText = styled(PSmall)`
  margin: 0;
`;

const FeatureList = styled.ul``;

const FeatureItem = styled.li``;

const HighlightBox = styled.div`
  background-color: #3e3e3e;
  width: 100%;

  border: solid #3e3e3e 2rem;
  border-radius: 1.5rem;
  margin: 2rem 0 3rem -2rem;
  box-sizing: content-box;

  ${ItemHeadline} {
    margin: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/routes/Home/components/SectionPricing.js